export default "__VITE_ASSET__lobHVnEV__"